module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Legal Notice"},"es":{"title":"Notas legales"},"fr":{"title":"Mentions Légales"},"it":{"title":"Note legali"},"pt":{"title":"Avisos Legais"},"pl":{"title":"Informacje prawne"}}')
  delete Component.options._Ctor
}
